export default __webpack_public_path__ + "static/media/class_vii_viii_ix.db51c6a6.png";